import { languageItem } from '@/language/helpers'
import CartExpiryModal from '@/modals/CartExpiryModal.vue'
import ExtendCartTimerModal from '@/modals/ExtendCartTimerModal.vue'
import { openModal } from '@/modals/helpers/api'
import { ModalCloseHandlerFn } from '@/modals/helpers/types'

export function openCartExpiryModal(onClose?: ModalCloseHandlerFn) {
  const language = languageItem('cartExpire')
  openModal({
    name: 'cart-expiry-modal',
    title: language.title,
    closeable: false,
    size: 'sm',
    component: CartExpiryModal,
    onClose,
    describedBy: 'cart-expiry-content',
  })
}

export function openExtendCartTimerModal(onClose: ModalCloseHandlerFn): void {
  const language = languageItem('extendCartTimerModal')
  openModal({
    name: 'extend-cart-timer-modal',
    title: language.title,
    closeable: false,
    size: 'md',
    component: ExtendCartTimerModal,
    onClose,
    describedBy: 'extend-cart-timer-content',
  })
}
